import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "folder",
  "use": "folder-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"folder\"><path d=\"M6.308 2.011c.055.11.12.322.157.45l.037.111c.055.166.12.34.185.506l.046.129c.148.395.527.661.953.661h7.297v9.12H1.017V2.011h5.29zM6.4 1H.925A.925.925 0 000 1.92v11.16c0 .506.416.92.925.92h14.15a.925.925 0 00.925-.92V3.778a.925.925 0 00-.925-.92h-7.39c-.073-.193-.157-.386-.212-.588C7.288 1.708 7.12 1 6.4 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol